import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as MagnetIcon } from "./magnet-vertical.svg";

export default function MediaFire(props: any) {
  return (
    <SvgIcon component={ MagnetIcon } {...props} />
  );
}
